<template>
  <div class="complaintcontent">
    <titlebar titleName="投诉举报" goback="true"></titlebar>
    <div class="content">
      <ul>
        <li class="item">
          <p>请选择投诉类型</p>
          <van-icon name="arrow" @click="showPopup" />
        </li>
        <li class="item">
          <input type="text" placeholder="投诉对象（如：xx游戏厂商运营）" />
        </li>
        <li class="item">
          <input type="text" placeholder="投诉对象的联系方式（非必填）" />
        </li>
        <li class="item">
          <input type="text" placeholder="您的称呼" />
        </li>
        <li class="item">
          <input type="text" placeholder="您的联系方式（QQ、手机等）" />
        </li>
        <li class="photo">
          <p>填写你要反馈的内容，下方可添加图片</p>
          <div class="Upload">
            <van-uploader :after-read="afterRead" class="upload" />
          </div>
        </li>
      </ul>
      <p class="tips">
        我们将对举报者的个人信息进行严格保密，被举报者无法获知 举报人信息
      </p>
      <div class="btn">提交</div>
    </div>
    <van-popup v-model="show" class="typecontent" position="bottom">
      <p class="title">请选择投诉类型</p>
      <div class="list">
        <p class="item">服务投诉</p>
        <p class="item">腐败投诉</p>
        <p class="item">侵权投诉</p>
        <p class="item">其他</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import titlebar from "../../components/index/titleBar.vue";
export default {
  components: {
    titlebar,
  },
  data() {
    return {
      show: false,
    };
  },

  methods: {
    showPopup() {
      this.show = true;
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
    },
  },
};
</script>

<style lang="less"  scoped>
.typecontent {
  height: 70vw;
  border-top-left-radius: 3vw;
  border-top-right-radius: 3vw;
  .title {
    color: #000;
    font-size: 5vw;
    margin: 3vw 0;
  }
  .list {
    width: 63.4667vw;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .item {
      width: 63.4667vw;
      height: 8.6667vw;
      line-height: 8.6667vw;
      text-align: center;
      background: #eeeeee;
      color: #a2a2a2;
      border-radius: 5vw;
      margin-bottom: 4vw;
    }
  }
}
.content {
  padding-top: 13vw;
  ul {
    width: 92vw;
    background: #fff;
    margin: 0 auto;
    margin-top: 4vw;
    border-radius: 3vw;
    padding: 0 3.2vw;
    .item {
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 82vw;
      height: 15vw;
      background: #fff;
      border-bottom: 0.3vw solid #f0f0f0;
      color: #bebebe;
      input {
        width: 80vw;
      }
      input::-webkit-input-placeholder {
        /* placeholder颜色  */
        color: #bebebe;
        /* placeholder字体大小  */
        /* placeholder位置  */
        text-align: left;
      }
    }
    .photo {
      margin: 0 auto;
      width: 82vw;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      p {
        margin-top: 4.6667vw;
        text-align: left;
        color: #bebebe;
        font-size: 3.5vw;
      }
      .upload {
        margin-top: 15vw;
      }
    }
  }
  .tips {
    width: 92vw;
    text-align: left;
    margin: 3vw auto;
    color: #949494;
    font-size: 3.5vw;
  }
  .btn {
    width: 92vw;
    height: 12.2667vw;
    background: #ffa623;
    color: #fff;
    font-size: 4vw;
    line-height: 12.2667vw;
    margin: 0 auto;
    border-radius: 3vw;
  }
}
</style>